function isObject(obj) {
  return obj !== null && typeof obj === 'object'
}

export function mergeDeep(...objects) {
  return objects.reduce((prev, obj) => {
    Object.keys(obj).forEach(key => {
      const pVal = prev[key]
      const oVal = obj[key]

      if (Array.isArray(pVal) && Array.isArray(oVal)) {
        prev[key] = pVal.concat(...oVal)
      } else if (isObject(pVal) && isObject(oVal)) {
        prev[key] = mergeDeep(pVal, oVal)
      } else {
        prev[key] = oVal
      }
    })

    return prev
  }, {})
}

/**
 * Merge page updates onto an existing page object.
 * Simple spread - whatever you pass gets applied.
 *
 * @param {Object} page - The existing page object
 * @param {Object} updates - The updates to apply (full replacement for each key)
 * @returns {Object} - The merged page object
 */
export function mergePageUpdates(page, updates) {
  const result = { ...page }
  for (const [key, value] of Object.entries(updates)) {
    if (key === 'id' || value === undefined) {
      continue
    }
    result[key] = value
  }
  return result
}
